import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/system";
import CustomTheme from "./components/common/theme";
import { CharactersContext } from "./components/hooks/Context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <ThemeProvider theme={CustomTheme}>
      <CharactersContext>
        <App />
      </CharactersContext>
    </ThemeProvider>
  </BrowserRouter>
);
